module.exports = __webpack_public_path__ + "img/bio-7.fcb46ad.jpg";